import React from 'react';
import styled from 'styled-components/native';

import Image from '@src/components/Image';
import { Body3 } from '@src/components/Typography';

type Props = {
  children: React.ReactNode;
};
const Icon = styled(Image)`
  width: 24px;
  height: 24px;
  resize-mode: contain;
`;

const Content = styled(Body3)`
  margin-start: 10px;
  margin-end: 16px;
`;

const Container = styled.View`
  flex-direction: row;
  align-items: flex-start;
  margin-top: 15px;
`;

const Component: React.FC<Props> = ({ children }) => {
  return (
    <Container>
      <Icon source={require('@src/assets/images/Cancel.png')} />
      <Content>{children}</Content>
    </Container>
  );
};

Component.displayName = 'Exclude';

export default React.memo(Component);
